const Main = () => (
    <div>Test</div>
);
export default Main;